import { Box } from "@mui/material";
import { DateRangePicker } from "@mui/x-date-pickers-pro";
import InfoTooltip from "../../../common/components/functional/InfoTooltip/InfoTooltip";
import InputHelperText from "../../../common/components/functional/error/InputHelperText";
import { NullableDateRange } from "../../../common/types/nullable";

// If reused elsewhere, extract this to a shared component and add an RHF wrapper.
interface Props {
  value: NullableDateRange;
  onChange: (value: NullableDateRange) => void;
  fromPlaceholder: string;
  toPlaceholder: string;
  tooltipText?: string;
  errorMessage?: string;
  rowWidth?: number;
  tooltipWidth?: number;
  tooltipGap?: number;
}

const TalentFiltersDateRange = ({
  value,
  onChange,
  fromPlaceholder,
  toPlaceholder,
  tooltipText,
  errorMessage,
  rowWidth = 300,
  tooltipWidth = 16,
  tooltipGap = 8,
}: Props) => {
  const dateRangeWidth = rowWidth - (tooltipWidth + tooltipGap);

  return (
    <Box width="100%" maxWidth={`${rowWidth}px`}>
      <Box display="flex" alignItems="center" gap={`${tooltipGap}px`}>
        <DateRangePicker
          value={[value.from, value.to]}
          onChange={(newValue) => {
            onChange({ from: newValue[0], to: newValue[1] });
          }}
          minDate={new Date(1970, 0, 1)}
          maxDate={new Date(2099, 11, 31)}
          slotProps={{
            textField: ({ position }) => ({
              size: "small",
              placeholder:
                position === "start" ? fromPlaceholder : toPlaceholder,
              label: null,
              sx: { flex: 1, minWidth: 0 },
            }),
          }}
          sx={{ width: dateRangeWidth }}
        />
        {tooltipText ? <InfoTooltip title={tooltipText} /> : null}
      </Box>
      {errorMessage ? <InputHelperText errorMessage={errorMessage} /> : null}
    </Box>
  );
};

export default TalentFiltersDateRange;
